import { render, staticRenderFns } from "./scrumbar.vue?vue&type=template&id=7d59250a"
import script from "./scrumbar.vue?vue&type=script&lang=js"
export * from "./scrumbar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports